import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { IWorkflow, IWorkflowUser, IWorkflowSecurity } from "../interfaces/iworkflow";
import { ICountryWorkflowConfigurationStatus } from "../interfaces/icountryworkflowconfigurationstatus";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class WorkflowConfigurationService extends BaseService {
    constructor(httpClient: HttpClient, toastsMgr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastsMgr, store);
    }

    /**
     * get workflow configration
     */
    getWorkflowConfiguration(countryCode: string): Observable<IWorkflow> {
        return super.get(`/api/workflowconfiguration/${countryCode}`).pipe(map((res: any) => res as IWorkflow));
    }

    /**
     * gets the status of the workflow configuration for every country including default option
     */
    getCountryWorkflowConfigurationStatus(): Observable<ICountryWorkflowConfigurationStatus[]> {
        return super.get("/api/workflowconfiguration/countryworkflowconfiguration").pipe(map((res: any) => res as ICountryWorkflowConfigurationStatus[]));
    }

    /**
     * searches for users that can be assigned to the workflow
     * @param searchTerm the term to search for - searches against username and email
     * @param includeGroups whether or not to include groups in the search
     */
    userSearch(searchTerm: string, includeGroups: boolean): Observable<IWorkflowSecurity[]> {
        return super.get(`/api/workflowconfiguration/workflowstageusersearch/${searchTerm}/${includeGroups}`).pipe(map((res: any) => res as IWorkflowUser[]));
    }

    createWorkflow(workflow: IWorkflow): Observable<IWorkflow> {
        return super.post("/api/workflowconfiguration", workflow).pipe(map((res: any) => res as IWorkflow));
    }

    updateWorkflow(workflow: IWorkflow): Observable<IWorkflow> {
        return super.put("/api/workflowconfiguration", workflow).pipe(map((res: any) => res as IWorkflow));
    }
}





